import { calculateAveragePriceAndMileage } from "./calculateAveragePriceAndMileage";
import {
  getAllRowsByMakeModelYearRange,
  getAvgByYearRange,
  getRowsByMakeModelYearRange,
} from "./rpcVehicleData";

export default async function getDataFromDatabase({
  vehicleData,
  setVehicleData,
  setAveragePrice,
  setAverageMileage,
  setFilteredData,
  initialRowLimit = 2000,
  soldOnly = false,
}) {
  const { year, make, model } = vehicleData;
  let normalizedMake = make?.toLowerCase();
  const normalizedModel = model?.toLowerCase();

  if (!normalizedMake || !normalizedModel) {
    return [];
  }

  let data = await getRowsByMakeModelYearRange({
    make: normalizedMake,
    model: normalizedModel,
    limit: initialRowLimit,
    soldOnly,
  });

  if (data.length === 0 && normalizedMake.split(" ").length > 1) {
    const makeWithHyphen = normalizedMake
      .toLowerCase()
      .split(" ")
      .filter((word) => word.trim() !== "")
      .join("-");

    const hyphenatedData = await getRowsByMakeModelYearRange({
      make: makeWithHyphen,
      model: normalizedModel,
      limit: initialRowLimit,
      soldOnly,
    });

    if (hyphenatedData.length > 0) {
      setVehicleData((prevVehicleData) => ({
        ...prevVehicleData,
        make: makeWithHyphen,
      }));
      normalizedMake = makeWithHyphen;
    }

    data = hyphenatedData;
  }

  let currAveragePrice = 0;
  let currAverageMileage = 0;
  try {
    const avgResult = await getAvgByYearRange({
      make: normalizedMake,
      model: normalizedModel,
      yearLow: parseInt(year),
      yearHigh: parseInt(year),
      includeRnm: true,
    });
    if (avgResult) {
      currAveragePrice = avgResult.avg_price || 0;
      currAverageMileage = avgResult.avg_mileage || 0;
    }
  } catch (error) {
    console.error("Error fetching averages from RPC:", error);
  }

  if (currAveragePrice === 0 && currAverageMileage === 0) {
    const [avgPriceFallback, avgMileageFallback] =
      calculateAveragePriceAndMileage(data, year);
    currAveragePrice = avgPriceFallback;
    currAverageMileage = avgMileageFallback;
  }

  setAveragePrice(currAveragePrice);
  setAverageMileage(currAverageMileage);
  setFilteredData(data);

  // Load the full dataset in the background for the sold vehicles list.
  (async () => {
    try {
      const fullData = await getAllRowsByMakeModelYearRange({
        make: normalizedMake,
        model: normalizedModel,
        soldOnly,
      });
      if (fullData.length > data.length) {
        setFilteredData(fullData);
      }
    } catch (error) {
      console.error("Error fetching full dataset via RPC:", error);
    }
  })();

  // Return data in the case we plan to use it right away
  return data;
}
